const sizes = {
    xxs: 444,
    xs:600,
    sm:800,
    xsm:840,
    md:960,
    xmd:1150,
    lg:1280,
    mlg:1350,
    xlg:1535,
    xxlg: 1400,
    xl:1600,
    xxl:2500
}

export default sizes;